var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2871 7.57038C15.2871 11.7125 11.9293 15.0704 7.78711 15.0704C3.64497 15.0704 0.287109 11.7125 0.287109 7.57038C0.287109 3.42824 3.64497 0.0703812 7.78711 0.0703812C11.9293 0.0703812 15.2871 3.42824 15.2871 7.57038ZM8.72461 11.3204C8.72461 11.8382 8.30489 12.2579 7.78711 12.2579C7.26935 12.2579 6.84961 11.8382 6.84961 11.3204C6.84961 10.8026 7.26935 10.3829 7.78711 10.3829C8.30489 10.3829 8.72461 10.8026 8.72461 11.3204ZM7.78711 2.88288C7.26935 2.88288 6.84961 3.30262 6.84961 3.82038V7.57038C6.84961 8.08816 7.26935 8.50788 7.78711 8.50788C8.30489 8.50788 8.72461 8.08816 8.72461 7.57038V3.82038C8.72461 3.30262 8.30489 2.88288 7.78711 2.88288Z",
    fill: "#D12600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.e498349ad7c8637d9859e266aaa55cac.svg";
export { ForwardRef as ReactComponent };